import { getCLS, getFID, getLCP, getFCP, getTTFB } from 'web-vitals';

const vitalsUrl = 'https://vitals.vercel-analytics.com/v1/vitals';

function getConnectionSpeed() {
  return 'connection' in navigator &&
    navigator['connection'] &&
    'effectiveType' in navigator['connection']
    ? (navigator['connection']['effectiveType'] as string)
    : '';
}

function sendToAnalytics(metric: any, options: { path: string }) {
  const body = {
    dsn: window.location.origin,
    id: metric.id,
    page: options.path,
    href: location.href,
    event_name: metric.name,
    value: metric.value.toString(),
    speed: getConnectionSpeed(),
  };

  if (navigator.sendBeacon) {
    navigator.sendBeacon(vitalsUrl, JSON.stringify(body));
  } else {
    fetch(vitalsUrl, {
      body: JSON.stringify(body),
      method: 'POST',
      keepalive: true,
    });
  }
}

export function initializeAnalytics() {
  try {
    getFID((metric) => sendToAnalytics(metric, { path: location.pathname }));
    getTTFB((metric) => sendToAnalytics(metric, { path: location.pathname }));
    getLCP((metric) => sendToAnalytics(metric, { path: location.pathname }));
    getCLS((metric) => sendToAnalytics(metric, { path: location.pathname }));
    getFCP((metric) => sendToAnalytics(metric, { path: location.pathname }));
  } catch (err) {
    console.error('[Analytics]', err);
  }
}

export function trackPageView(path: string) {
  try {
    if (typeof window !== 'undefined') {
      window.gtag?.('config', process.env.GA_TRACKING_ID, {
        page_path: path,
      });
    }
  } catch (err) {
    console.error('[Analytics]', err);
  }
}

export function trackEvent(action: string, category: string, label: string, value?: number) {
  try {
    if (typeof window !== 'undefined') {
      window.gtag?.('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
    }
  } catch (err) {
    console.error('[Analytics]', err);
  }
}